import { GuidService } from 'ui-components/services/guid-service';
import * as BulkUpdateActions from '../../../store/bulk/update/bulk.update.actions';
import { BulkActions } from '../../../enums/bulk-actions';

export const DoNotNotifyMarketplace = {
  id: 'do-not-notify-marketplace',
  name: BulkActions.doNotNotifyMarketplace.message,

  makeHandler: (dispatch, bulkUpdateTypeData) => {
    return (ids, filters) =>
      dispatch(
        BulkUpdateActions.startBulkUpdateDoNotNotifyMarketPlaceJob(
          bulkUpdateTypeData,
          [BulkActions.doNotNotifyMarketplace],
          ids,
          GuidService.newGuid(),
          filters,
        ),
      );
  },
};
